import React from "react";

const HCPMarketingBanner = ({ title, topic, description, image }) => {
  return (
    <div className="conference-hero">
      <div className="container inner-content">
        <div className="row align-items-center justify-content-between banner-hero-container">
          <div className="col-lg-7 col-md-9 col-sm-12">
            <h1>{title}</h1>
            <h3 className="title-ext text-primary">{topic}</h3>
            <h6
              className="lh-base"
              style={{
                fontWeight: "400",
                color: "var($primary)",
              }}
              dangerouslySetInnerHTML={{ __html: description }}
            ></h6>
          </div>

          <div className="col-lg-5 col-md-6 col-sm-12">
            <div
              className="banner-img"
              style={{
                marginLeft: "auto",
              }}
            >
              <img
                src={image}
                style={{
                  width: "100%",
                  objectFit: "contain",
                  borderRadius: "10px",
                }}
                alt=""
              />
            </div>
          </div>
        </div>
        <div></div>
      </div>
    </div>
  );
};

export default HCPMarketingBanner;
